import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import PageContent from "../../components/PageContent";
import { useContext } from "react";
import AuthContext from "../../context/AuthContext";

function UpdatePassword() {
    const navigate = useNavigate();
    const { wait } = useContext(AuthContext);

    useEffect(() => {
        if (!wait) {
            navigate('/profile', { replace: true, state: { openPassword: true } });
        }
    }, [wait, navigate]);

    return (
        <PageContent wait={wait}>
            <Box className="flex justify-center py-20">
                <CircularProgress size={70} />
            </Box>
        </PageContent>
    );
}

export default UpdatePassword;
